import React from "react";
import { Link } from "react-router-dom";
import { Play, Heart, Eye } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export default function VideoCard({ video }) {
  const thumb = video.thumbnail_url ? mediaUrl(video.thumbnail_url) : null;
  return (
    <Link
      to={`/app/videos/${video.id}`}
      data-testid={`video-card-${video.id}`}
      className="group block bg-[#141414] border border-[#2a2a2a] hover:border-[#ff4500]/50 transition-colors duration-200 rounded-sm overflow-hidden"
    >
      <div className="relative aspect-video bg-black overflow-hidden">
        {thumb ? (
          <img src={thumb} alt={video.title} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition" />
        ) : (
          <video src={mediaUrl(video.video_url)} className="w-full h-full object-cover" muted preload="metadata" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
          <div className="w-14 h-14 bg-[#ff4500] flex items-center justify-center">
            <Play className="w-6 h-6 text-white ml-1" />
          </div>
        </div>
        <div className="absolute bottom-2 left-3 right-3 flex justify-between items-end">
          <div className="text-[10px] uppercase tracking-[0.2em] text-white/90 font-mono">MP4</div>
          <div className="flex items-center gap-3 text-[11px] text-white/80">
            <span className="flex items-center gap-1"><Eye className="w-3 h-3" />{video.views || 0}</span>
            <span className="flex items-center gap-1"><Heart className="w-3 h-3" />{video.likes?.length || 0}</span>
          </div>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-display text-base leading-snug line-clamp-2">{video.title}</h3>
        <div className="text-xs text-[#a3a3a3] mt-2 flex items-center gap-2">
          <span>{video.owner_name || "Unknown"}</span>
          <span className="text-[#2a2a2a]">·</span>
          <span className="font-mono uppercase tracking-wider text-[10px]">
            {new Date(video.created_at).toLocaleDateString()}
          </span>
        </div>
      </div>
    </Link>
  );
}
